export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select alignments"])},
        "network_select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Network Select"])},
        "separator_element": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seperator Element"])},
        "classification_select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Classification Select"])},
        "toggleText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toggle text"])},
        "noObjectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No objectives aligned yet!"])},
        "noSelections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No selections"])},
        "browseObjectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Browse for objectives above etc"])},
        "objectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aligned objectives"])},
        "defaultSelect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select"])},
        "defaultNetwork": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select network"])}
      },
      "fr": {
        "select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionnez les alignements"])},
        "network_select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection du réseau"])},
        "separator_element": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Élément séparateur"])},
        "classification_select": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection de Classement"])},
        "toggleText": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Basculer le texte"])},
        "noObjectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun objectif encore aligné!"])},
        "noSelections": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune sélection"])},
        "browseObjectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherchez les objectifs ci-dessus, etc."])},
        "objectives": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Objectifs alignés"])},
        "defaultSelect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner"])},
        "defaultNetwork": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionnez réseau"])}
      }
    }
  })
}